.table-cell-action-button-container {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
  z-index: 10;
}

.table-cell-action-button-container--inactive {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

.table-cell-action-button-container--active {
  opacity: 1;
  transition: opacity 0.3s;
}

.table-cell-action-button {
  background-color: var(--mantine-color-gray-0);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--mantine-color-gray-4);
  position: relative;
  margin-left: -28px;
  margin-top: -5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.table-cell-action-button:hover {
  background-color: var(--mantine-color-gray-2);
}

.table-cell-action-button .chevron-down {
  display: block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid var(--mantine-color-gray-7);
}

.table-action-menu-dropdown {
  background-color: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 4px 0;
  position: fixed;
  z-index: 100;
  opacity: 0;
  min-width: 180px;
}

.table-action-menu-item {
  background: none;
  border: 0;
  width: 100%;
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  color: var(--mantine-color-gray-9);
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
}

.table-action-menu-item:hover {
  background-color: var(--mantine-color-gray-1);
}

.table-action-menu-item .text {
  flex: 1;
}

.table-action-menu-dropdown hr {
  border: none;
  border-top: 1px solid var(--mantine-color-gray-3);
  margin: 4px 0;
}
